module.exports = __webpack_public_path__ + "static/media/communications-square.d1c0cc6e.jpg";